const globalUtils = {
  isUserMe: (userId: string, loggedInUserId: string) => {
    return userId === loggedInUserId;
  },
  isUserIdExists: <T extends { userId: string }>(userId: string, arr: T[]) => {
    const userIdExists = arr.some((element: T) => element.userId === userId);
    return userIdExists;
  },
  newLineSplit: (value: string) => value.split(/\n+/).filter(Boolean),
  checkIsSingular: (length: number) => {
    if (length === 0 || length === 1) return true;
    return false;
  },
  download: (data: any, filename: string) => {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },
  snakeCaseToCapitalize: (word: string) => {
    const cWord = word
      .split("_")
      .map((el) =>
        ["clap", "id"].includes(el.toLowerCase())
          ? el.toUpperCase()
          : el.charAt(0).toUpperCase() + el.slice(1).toLowerCase(),
      )
      .join(" ");
    return cWord;
  },
  eliminateEmptyString: (obj: object) => {
    const result = Object.fromEntries(
      Object.entries(obj).filter(([, v]) => v !== ""),
    );
    return result;
  },
  removeTokens: () => {
    // localStorage.removeItem(ACCESS_TOKEN_NAME);
    localStorage.clear();
  },
  isValidUuid: (uuid: string) => {
    const regexExp =
      /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
    return regexExp.test(uuid);
  },
  getWindowHeight: () => {
    return window.innerHeight;
  },
  isNullOrUndefined: (value: any) => {
    return value === null || value === undefined;
  },
  isNullOrEmpty: (value: any) => {
    return value === null || value === undefined || value === "";
  },
  isString: (value: any) => {
    return typeof value === "string";
  },
};

export default globalUtils;
